var map = {
	"./affix/style/index.tsx": 19,
	"./alert/style/index.tsx": 29,
	"./anchor/style/index.tsx": 30,
	"./auto-complete/style/index.tsx": 31,
	"./avatar/style/index.tsx": 20,
	"./back-top/style/index.tsx": 32,
	"./badge/style/index.tsx": 33,
	"./breadcrumb/style/index.tsx": 21,
	"./button/style/index.tsx": 1,
	"./calendar/style/index.tsx": 34,
	"./card/style/index.tsx": 35,
	"./carousel/style/index.tsx": 36,
	"./cascader/style/index.tsx": 37,
	"./checkbox/style/index.tsx": 10,
	"./col/style/index.tsx": 17,
	"./collapse/style/index.tsx": 38,
	"./comment/style/index.tsx": 39,
	"./config-provider/style/index.tsx": 40,
	"./date-picker/style/index.tsx": 11,
	"./descriptions/style/index.tsx": 41,
	"./divider/style/index.tsx": 42,
	"./drawer/style/index.tsx": 43,
	"./dropdown/style/index.tsx": 6,
	"./empty/style/index.tsx": 2,
	"./form/style/index.tsx": 44,
	"./grid/style/index.tsx": 5,
	"./icon/style/index.tsx": 45,
	"./image/style/index.tsx": 46,
	"./input-number/style/index.tsx": 47,
	"./input/style/index.tsx": 7,
	"./layout/style/index.tsx": 48,
	"./list/style/index.tsx": 49,
	"./locale-provider/style/index.tsx": 50,
	"./mentions/style/index.tsx": 51,
	"./menu/style/index.tsx": 12,
	"./message/style/index.tsx": 52,
	"./modal/style/index.tsx": 53,
	"./notification/style/index.tsx": 54,
	"./page-header/style/index.tsx": 55,
	"./pagination/style/index.tsx": 8,
	"./popconfirm/style/index.tsx": 56,
	"./popover/style/index.tsx": 13,
	"./progress/style/index.tsx": 14,
	"./radio/style/index.tsx": 15,
	"./rate/style/index.tsx": 57,
	"./result/style/index.tsx": 58,
	"./row/style/index.tsx": 18,
	"./select/style/index.tsx": 4,
	"./skeleton/style/index.tsx": 22,
	"./slider/style/index.tsx": 59,
	"./space/style/index.tsx": 60,
	"./spin/style/index.tsx": 9,
	"./statistic/style/index.tsx": 61,
	"./steps/style/index.tsx": 62,
	"./switch/style/index.tsx": 63,
	"./table/style/index.tsx": 64,
	"./tabs/style/index.tsx": 16,
	"./tag/style/index.tsx": 23,
	"./time-picker/style/index.tsx": 65,
	"./timeline/style/index.tsx": 66,
	"./tooltip/style/index.tsx": 3,
	"./transfer/style/index.tsx": 67,
	"./tree-select/style/index.tsx": 68,
	"./tree/style/index.tsx": 24,
	"./typography/style/index.tsx": 69,
	"./upload/style/index.tsx": 70,
	"./version/style/index.tsx": 28
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;